import * as actions from './actions'

// GENERIC REQUEST REDUCER

export const fetching = () => ({ type: actions.FETCHING })
export const success = response => ({ type: actions.SUCCESS, response })
export const error = response => ({ type: actions.ERROR, response })
export const reset = () => ({ type: actions.RESET })
